import { cn } from "@/lib/utils";

/** Grid of selectable option pills. */
export function OptionGrid({ options, value, onChange, columns = 2, testIdPrefix = "opt" }) {
  return (
    <div
      className={cn(
        "grid gap-3",
        columns === 3 ? "sm:grid-cols-3 grid-cols-1" : "sm:grid-cols-2 grid-cols-1"
      )}
    >
      {options.map((opt) => {
        const active = value === opt;
        return (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(opt)}
            data-testid={`${testIdPrefix}-${opt.toString().toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className={cn(
              "text-left px-4 py-3 rounded-xl border transition-all font-medium text-sm",
              active
                ? "border-primary bg-primary/5 text-foreground ring-2 ring-primary/20"
                : "border-border hover:border-primary/40 hover:bg-accent"
            )}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}

export function MultiOptionGrid({
  options,
  value = [],
  onChange,
  columns = 2,
  testIdPrefix = "multi",
}) {
  const toggle = (opt) => {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  };
  return (
    <div
      className={cn(
        "grid gap-3",
        columns === 3 ? "sm:grid-cols-3 grid-cols-1" : "sm:grid-cols-2 grid-cols-1"
      )}
    >
      {options.map((opt) => {
        const active = value.includes(opt);
        return (
          <button
            key={opt}
            type="button"
            onClick={() => toggle(opt)}
            data-testid={`${testIdPrefix}-${opt.toString().toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className={cn(
              "flex items-center gap-2 text-left px-4 py-3 rounded-xl border transition-all font-medium text-sm",
              active
                ? "border-primary bg-primary/5 text-foreground ring-2 ring-primary/20"
                : "border-border hover:border-primary/40 hover:bg-accent"
            )}
          >
            <span
              className={cn(
                "w-4 h-4 rounded border flex items-center justify-center text-primary",
                active ? "bg-primary border-primary" : "border-border"
              )}
            >
              {active && (
                <svg viewBox="0 0 12 10" className="w-3 h-3 text-white">
                  <path
                    d="M1 5l3 3L11 1"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </span>
            {opt}
          </button>
        );
      })}
    </div>
  );
}
